const imagesPathName = require('./buildImagesFolderAnnotator');

window.imagesPathName = imagesPathName;
global.imagesPathName = imagesPathName;
